
export default function Areas() {
  const areas = [
    {
      icon: 'ri-heart-pulse-line',
      title: 'Ansiedade',
      description: 'Trabalho terapêutico para compreender e gerenciar sintomas de ansiedade, desenvolvendo estratégias práticas para lidar com preocupações excessivas, medos e tensões do dia a dia.',
      color: 'bg-[#A8D5E2]/10',
      iconColor: 'text-[#A8D5E2]'
    },
    {
      icon: 'ri-sun-line',
      title: 'Depressão',
      description: 'Acompanhamento especializado para identificar padrões de pensamento negativos, promovendo o resgate da motivação, do prazer nas atividades e da qualidade de vida emocional.',
      color: 'bg-[#F4C2C2]/10',
      iconColor: 'text-[#F4C2C2]'
    },
    {
      icon: 'ri-leaf-line',
      title: 'Luto',
      description: 'Suporte acolhedor no processo de elaboração do luto, auxiliando na compreensão e aceitação das perdas, respeitando o tempo e as emoções de cada pessoa nessa jornada delicada.',
      color: 'bg-[#B8E6D5]/10',
      iconColor: 'text-[#B8E6D5]'
    },
    {
      icon: 'ri-star-line',
      title: 'Autoestima',
      description: 'Desenvolvimento de uma autoimagem mais positiva e realista, trabalhando crenças limitantes e fortalecendo a confiança pessoal para uma vida mais plena e autêntica.',
      color: 'bg-[#E8D4A2]/10',
      iconColor: 'text-[#D4AF37]'
    },
    {
      icon: 'ri-team-line',
      title: 'Relacionamentos Interpessoais',
      description: 'Aprimoramento das habilidades de comunicação e relacionamento, trabalhando questões de vínculos afetivos, familiares e profissionais para conexões mais saudáveis e satisfatórias.',
      color: 'bg-[#A8D5E2]/10',
      iconColor: 'text-[#A8D5E2]'
    }
  ];

  return (
    <section id="areas" className="py-24 bg-[#FAFAFA]">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-light text-gray-800 mb-4">
            Áreas de Atuação
          </h2>
          <div className="w-16 h-1 bg-[#F4C2C2] mx-auto mb-6"></div>
          <p className="text-base text-gray-600 max-w-2xl mx-auto">
            Atendimento especializado em diversas áreas da saúde mental, sempre com uma abordagem acolhedora, ética e baseada em evidências científicas.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {areas.map((area, index) => (
            <div
              key={index}
              className="bg-white p-8 rounded-xl shadow-sm hover:shadow-lg transition-all duration-300 group cursor-pointer"
            >
              <div className={`w-14 h-14 flex items-center justify-center ${area.color} rounded-full mb-5 group-hover:scale-110 transition-transform duration-300`}>
                <i className={`${area.icon} text-2xl ${area.iconColor}`}></i>
              </div>
              <h3 className="text-lg font-medium text-gray-800 mb-3">
                {area.title}
              </h3>
              <p className="text-sm text-gray-600 leading-relaxed">
                {area.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
